module.exports = __webpack_public_path__ + "img/measurement_info_left_chest_front.dcbfe954.jpg";